import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardQueueComponent } from './dashboard-queue.component';
import { DashboardHeaderComponent } from './components/dashboard-header/dashboard-header.component';
import { DashboardMenuComponent } from './components/dashboard-menu/dashboard-menu.component';
import { DashboardCardsComponent } from './components/dashboard-cards/dashboard-cards.component';
import { NzButtonModule, NzDatePickerModule, NzModalModule, NzSelectModule } from 'ng-zorro-antd';
import { SharedModule } from '../shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { RouterModule } from '@angular/router';
import { DistributionByQueueComponent } from './pages/distribution-by-queue/distribution-by-queue.component';
import { CoreModule } from '../core/core.module';

@NgModule({
  declarations: [
    DashboardQueueComponent,
    DashboardHeaderComponent,
    DashboardMenuComponent,
    DashboardCardsComponent,
    DistributionByQueueComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    CoreModule,
    SharedModule,
    NzDatePickerModule,
    NzModalModule,
    NzButtonModule,
    NzSelectModule,
    ChartsModule
  ],
  exports: [
    DashboardQueueComponent,
    DashboardHeaderComponent,
    DashboardMenuComponent,
    DashboardCardsComponent
  ],
  entryComponents: [
    DistributionByQueueComponent
  ]
})
export class DashboardQueueModule { }
